import { useEffect } from 'react';
import Zoom from 'ol/control/Zoom';

const ZoomControl = ({ map, onChange }) => {
    useEffect(() => {
        if (!map) return;
        let zoomScreenControl = new Zoom();
        map.controls.push(zoomScreenControl);
        zoomScreenControl.on('change', () => {
            console.log('change');
        });
        return () => map.controls.remove(zoomScreenControl);
    }, [map]);
    return null;
};
export default ZoomControl;
